var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3452 21.7773H34.0279C34.5647 21.7773 35 22.2078 35 22.7387V27.8579C35 29.8094 33.4004 31.3913 31.4273 31.3913H31.4104C29.4372 31.3916 27.8374 29.8099 27.8372 27.8584C27.8372 27.8583 27.8372 27.8581 27.8372 27.8579V22.2798C27.8372 22.0023 28.0646 21.7773 28.3452 21.7773Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.186 20.7649C33.4575 20.7649 34.4883 19.7455 34.4883 18.4879C34.4883 17.2304 33.4575 16.2109 32.186 16.2109C30.9145 16.2109 29.8837 17.2304 29.8837 18.4879C29.8837 19.7455 30.9145 20.7649 32.186 20.7649Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0232 20.7655C26.8599 20.7655 28.3488 19.293 28.3488 17.4765C28.3488 15.66 26.8599 14.1875 25.0232 14.1875C23.1865 14.1875 21.6976 15.66 21.6976 17.4765C21.6976 19.293 23.1865 20.7655 25.0232 20.7655Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4575 21.7773H20.0773C19.5469 21.7903 19.1272 22.2257 19.1395 22.7504V28.5891C19.0655 31.7376 21.5841 34.3503 24.7674 34.4274C27.9508 34.3503 30.4694 31.7376 30.3954 28.5891V22.7504C30.4076 22.2257 29.988 21.7903 29.4575 21.7773Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.2791 21.7773V29.9594C25.2765 30.3346 25.0466 30.6716 24.6958 30.8145C24.5841 30.8612 24.4641 30.8853 24.3428 30.8853H19.5898C19.5233 30.7184 19.4619 30.5514 19.4107 30.3793C19.2316 29.7987 19.1402 29.1951 19.1395 28.5881V22.7489C19.1272 22.225 19.5462 21.7903 20.0758 21.7773H25.2791Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7675 21.7773V30.4654C24.7674 30.5853 24.7431 30.704 24.6958 30.8145C24.5514 31.1615 24.2106 31.3888 23.8312 31.3913H19.8303C19.7433 31.2244 19.6614 31.0574 19.5898 30.8853C19.5182 30.7133 19.4619 30.5514 19.4107 30.3793C19.2316 29.7987 19.1402 29.1951 19.1395 28.5881V22.7489C19.1272 22.225 19.5462 21.7903 20.0758 21.7773H24.7675Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7675 21.7773V29.4534C24.7636 29.9632 24.3467 30.3755 23.8312 30.3793H19.4107C19.2316 29.7987 19.1402 29.1951 19.1395 28.5881V22.7489C19.1272 22.225 19.5462 21.7903 20.0758 21.7773H24.7675Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.2558 21.7773V29.4534C24.2519 29.9632 23.835 30.3755 23.3195 30.3793H19.4107C19.2316 29.7987 19.1402 29.1951 19.1395 28.5881V22.7489C19.1272 22.225 19.5462 21.7903 20.0758 21.7773H24.2558Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.2791 19.1623V20.7562C25.1921 20.7613 25.1103 20.7663 25.0233 20.7663C24.9363 20.7663 24.8545 20.7613 24.7675 20.7562C24.5948 20.7449 24.4235 20.7178 24.2558 20.6752C23.2198 20.4326 22.3639 19.714 21.9535 18.7423C21.8829 18.5792 21.8281 18.4097 21.7898 18.2363H24.3428C24.8591 18.2383 25.2771 18.6517 25.2791 19.1623Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7674 19.6682V20.7561C24.5947 20.7447 24.4235 20.7176 24.2558 20.6751C23.2198 20.4324 22.3638 19.7138 21.9535 18.7422H23.8312C24.3474 18.7441 24.7655 19.1576 24.7674 19.6682Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7674 19.6682V20.7561C24.5947 20.7447 24.4235 20.7176 24.2558 20.6751C23.2198 20.4324 22.3638 19.7138 21.9535 18.7422H23.8312C24.3474 18.7441 24.7655 19.1576 24.7674 19.6682Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.2558 19.6682V20.6751C23.2198 20.4324 22.3638 19.7138 21.9535 18.7422H23.3195C23.8358 18.7441 24.2539 19.1576 24.2558 19.6682Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9378 18.7422H23.318C23.8359 18.7422 24.2558 19.1574 24.2558 19.6697V28.9467C24.2558 29.4589 23.8359 29.8742 23.318 29.8742H13.9378C13.4199 29.8742 13 29.4589 13 28.9467V19.6697C13 19.1574 13.4199 18.7422 13.9378 18.7422Z",
    fill: "url(#paint0_linear_18640_184786)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.096 22.2726H19.2209V27.3225H18.0262V22.2726H16.1598V21.293H21.096V22.2726Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18640_184786",
    x1: 14.9554,
    y1: 18.0175,
    x2: 22.1793,
    y2: 30.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/MicrosoftTeams.690278460e92522fea7c83f5e0ba5bc8.svg";
export { ForwardRef as ReactComponent };